module.exports = __webpack_public_path__ + "static/img/002城市名片2.5185113.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/002城市名片2.jpg
// module id = eelC
// module chunks = 0